import React, { FC, useState } from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { isTouchDevice } from '../../../utils/domUtils';
import { numberWithSpaces } from '../../../utils/math';
import { Hyperlink } from '../../../components/Hyperlink';
import { MaterialIcon } from '../../../components/material-icon/MaterialIcon';
import styles from './entity_block_line.module.scss';

type Props = {
  label: string;
  value: number;
  url?: string;
  source: string;
  indent?: boolean;
};

export const EntityBlockLine: FC<Props> = ({
  label,
  value,
  url,
  source,
  indent = false,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Hyperlink
        className={classNames('entity__block__value-line pointer', {
          'entity__block__touch-line': isTouchDevice(),
        })}
        href={url}
        source={source}
      >
        <span
          className={classNames('entity__block__label', {
            entity__block__indent: indent,
          })}
        >
          <span>{label}</span>
          <span className="entity__indicator vertical-align-elements">
            {' '}
            <span>
              <FormattedMessage id="entity/expertises/BlockLine.tsx/1" />
            </span>
            <MaterialIcon
              name="arrow_forward"
              className="entity__indicator__icon"
            />
          </span>
        </span>
        <span
          className={classNames(styles.value, {
            [styles.hover]: isHovered,
          })}
        >
          {numberWithSpaces(value)}
        </span>
      </Hyperlink>
    </div>
  );
};
